import React, { useEffect, useState } from "react";
import styles from "./subscription.module.css";
import { Link } from "react-router-dom";
import Layout from "../../Components/Layout";
import ProPlanTab from "./proPlanTab";
import EnterprisePlanTab from "./enterprisePlanTab";
import { creditPricing } from "../../Services/APIrequests";

const SubscriptionPage = () => {
  const [pricingData, setPricingData] = useState([]);
  const [activeTab, setActiveTab] = useState("Current Plan");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const fetchCreditPricing = async () => {
      try {
        const response = await creditPricing();
        setPricingData(response.data);
        console.log("fetching credit pricing:", response.data);
      } catch (error) {
        console.error("Error fetching credit pricing:", error);
      }
    };
    fetchCreditPricing();
  }, []);

  // This function will now return all pricing data
  const getFilteredData = () => {
    // Return all pricing data
    return pricingData;
  };

  // Call getFilteredData which will now return all plans
  const filteredData = getFilteredData();

  return (
    // <Layout Active={"My Credits"}>
      <div className={styles.subscription_page}>
        <h2>Buy More Credits</h2>
        <div className={styles.pricingcontainer}>
          {/* <div className={styles.subscription_pageheader}>
            <input type="text" placeholder="Search for Company Name or CIN" />
          </div> */}
        </div>
        <div className={styles.subscription_pagecontainer}>
          <div className={styles.subscription_pagetabs}>
            {["Current Plan", "Enterprise Plan"].map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabClick(tab)}
                className={`${styles.subscription_pagetab} ${
                  activeTab === tab ? styles.subscription_pageactiveTab : ""
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Render Tab Components Based on activeTab */}
          <div>
            {activeTab === "Current Plan" && <ProPlanTab data={filteredData} />}
            {activeTab === "Enterprise Plan" && (
              <EnterprisePlanTab data={filteredData} />
            )}
            {/* Render All Plans */}
            {activeTab !== "Current Plan" && activeTab !== "Enterprise Plan" && (
              <div>
                {filteredData.map((plan, index) => (
                  <div key={plan.creditPricingId}>
                    <h3>{plan.planName}</h3>
                    <p>Min Credits: {plan.minCredits}</p>
                    <p>Max Credits: {plan.maxCredits}</p>
                    <p>Price Per Credit: {plan.pricePerCredit}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    // </Layout>
  );
};

export default SubscriptionPage;
